export default __webpack_public_path__ + "static/media/order-color.f73248d4.svg";